export default "__VITE_ASSET__BDeQt6j5__"